/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const FacebookNew = defineMessages({
  titleOne: {
    id: 'Facebook.FacebookNew.titleOne',
    defaultMessage: 'Your customers are on Facebook Messenger'
  },
  titleTwo: {
    id: 'Facebook.FacebookNew.titleTwo',
    defaultMessage: 'Your assistant can be too'
  },
  subtitle: {
    id: 'Facebook.FacebookNew.subtitle',
    defaultMessage:
      'Through Facebook Messenger, your assistant is ready to join one of the best places to communicate with all the people and businesses in the world. <link>Learn more</link>'
  },
  instructions: {
    id: 'Facebook.FacebookNew.instructions',
    defaultMessage: 'What you’ll need'
  },
  instructionsDescription: {
    id: 'Facebook.FacebookNew.instructionsDescription',
    defaultMessage:
      "Select Create to get all the details, but here's what to expect:"
  },
  instructionsItemOne: {
    id: 'Facebook.FacebookNew.instructionsItemOne',
    defaultMessage:
      'Create a Facebook account to setup a basic integration when using Facebook Messenger. Once authorized, you can start assigning that assistant to conversations.'
  },
  instructionsItemTwo: {
    id: 'Facebook.FacebookNew.instructionsItemTwo',
    defaultMessage:
      'Create your very own Facebook App or pick a previously created app you plan to use.'
  },
  facebookForDevelopers: {
    id: 'Facebook.FacebookNew.facebookForDevelopers',
    defaultMessage: '<link>Facebook for Developers</link>'
  },
  gdprTitle: {
    id: 'Facebook.FacebookNew.gdprTitle',
    defaultMessage: 'GDPR warning:'
  },
  gdprDescription: {
    id: 'Facebook.FacebookNew.gdprDescription',
    defaultMessage: 'Facebook integrations are not currently GDPR compliant.'
  },
  closeWarning: {
    id: 'Facebook.FacebookNew.closeWarning',
    defaultMessage: 'close warning'
  }
});

export const FacebookQuickSetup = defineMessages({
  title: {
    id: 'Facebook.FacebookQuickSetup.title',
    defaultMessage: 'Set up Facebook Messenger'
  },
  applicationSecret: {
    id: 'Facebook.FacebookQuickSetup.applicationSecret',
    defaultMessage: 'Application secret'
  },
  pageAccessToken: {
    id: 'Facebook.FacebookQuickSetup.pageAccessToken',
    defaultMessage: 'Page access token'
  },
  webhook: {
    id: 'Facebook.FacebookQuickSetup.webhook',
    defaultMessage: 'Webhook'
  },
  connectAssistant: {
    id: 'Facebook.FacebookQuickSetup.connectAssistant',
    defaultMessage: 'Connect assistant'
  },
  appReview: {
    id: 'Facebook.FacebookQuickSetup.appReview',
    defaultMessage: 'Application review'
  }
});

export const IntroStepMessages = defineMessages({
  title: {
    id: 'Facebook.IntroStepMessages.title',
    defaultMessage: 'Set up Facebook Messenger'
  },
  instructions: {
    id: 'Facebook.IntroStepMessages.instructions',
    defaultMessage: 'Steps to setting up Facebook Messenger'
  }
});

export const ConnectAssistantStepMessages = defineMessages({
  title: {
    id: 'Facebook.ConnectAssistantStepMessages.title',
    defaultMessage: 'Connect your assistant'
  },
  note: {
    id: 'Facebook.ConnectAssistantStepMessages.note',
    defaultMessage:
      'Note: Subscribe to only one page. Multiple-page subscriptions are not currently supported.'
  },
  message: {
    id: 'Facebook.ConnectAssistantStepMessages.message',
    defaultMessage:
      'Congrats! You should be able to test your bot now in Messenger. You must be a Page admin to interact with it until you make it public.'
  }
});

export const AppReviewStepMessages = defineMessages({
  title: {
    id: 'Facebook.AppReviewStepMessages.title',
    defaultMessage: 'Start app review process'
  },
  description: {
    id: 'Facebook.AppReviewStepMessages.description',
    defaultMessage:
      "Once you have confirmed your bot is working in Messenger, and you would like to make the bot public, go to <link>Submitting Your Messenger App</link> on Facebook for Developer's site and follow the instructions to start the app review process."
  }
});
